import React, { useRef, useEffect, useState } from "react"
import * as styles from "./Header-tw-styles"
import { HeaderPropTypes } from "./propTypes"
import Link from "../../UI/Link/Link"
import BurgerIcon from "../../../assets/BurgerIcon"
import ChevronLeftIcon from "../../../assets/ChevronLeftIcon"
import ChevronRightIcon from "../../../assets/ChevronRightIcon"
import useClickOutsideHandler from "../../../hooks/useClickOutsideHandler"
import { gaEventClasses, gaEventLabels } from "../../../constants/gtm.constants"

function HeaderMobile(props) {
    const { logo, menuElementsCollection, mainCta } = props
    const style = styles.mobileStyles
    const [mobileNavVisible, setMobileNavVisible] = useState(false)
    const [activeDropdown, setActiveDropdown] = useState(null)
    const mobileNavRef = useRef()
    const menuButtonRef = useRef()

    const onClickOutside = () => {
        setMobileNavVisible(false)
    }
    useClickOutsideHandler([mobileNavRef, menuButtonRef], onClickOutside)

    useEffect(() => {
        if (mobileNavVisible) {
            setActiveDropdown(null)
        }
    }, [mobileNavVisible])

    return (
        <header className={style.header}>
            <div className={style.borderBottom}>&nbsp;</div>
            <div className={style.wrapper}>
                <div className={style.logoWrapper}>
                    <Link
                        url={`/`}
                        gaEventClass={gaEventClasses.headerLogo}
                        gaEventLabel = {gaEventLabels.headerLogo}>
                        <img src={logo.url} width={logo.width} height={logo.height} alt={logo.title} loading="eager" />
                    </Link>
                </div>
                <div className={style.content}>
                    <div className={style.mainCtaWrapper}>
                        <Link {...mainCta} />
                    </div>
                    <button
                        className={style.mobileMenuButton}
                        onClick={() => {
                            setMobileNavVisible(prevState => !prevState)
                        }}
                        ref={menuButtonRef}
                    >
                        <BurgerIcon active={mobileNavVisible} />
                    </button>
                </div>
            </div>
            <div
                className={`${style.mobileNavigation} ${
                    mobileNavVisible ? style.mobileNavigationVisible : style.mobileNavigationHidden
                }`}
                ref={mobileNavRef}
            >
                <div className={style.mobileNavigationInner}>
                    <nav className={style.mobileNav}>
                        <ul className={style.mobileNavList}>
                            {activeDropdown ? (
                                <>
                                    <li>
                                        <button
                                            className={style.navigationButton}
                                            onClick={() => {
                                                setActiveDropdown(null)
                                            }}
                                        >
                                            <ChevronLeftIcon />
                                        </button>
                                    </li>
                                    {activeDropdown?.link && (
                                        <li>
                                            <Link
                                                onClick={onClickOutside}
                                                {...activeDropdown.link}
                                                className={style.navigationButton}
                                            />
                                        </li>
                                    )}
                                    {Array.isArray(activeDropdown?.dropdownLinksCollection?.items) &&
                                        activeDropdown.dropdownLinksCollection.items.map(dropdownItem => (
                                            <li key={dropdownItem.sys.id} className="pl-4">
                                                <Link
                                                    onClick={onClickOutside}
                                                    {...dropdownItem}
                                                    className={style.navigationButton}
                                                />
                                            </li>
                                        ))}
                                </>
                            ) : (
                                menuElementsCollection.items.map(item => {
                                    return (
                                        <React.Fragment key={`${item.sys.id}_mobile_menu_link`}>
                                            {item.__typename === "MenuElement" && (
                                                <li key={`mobile_dd_${item.sys.id}`}>
                                                    <button
                                                        className={style.navigationButton}
                                                        onClick={() => setActiveDropdown(item)}
                                                    >
                                                        {item.link.title}
                                                        <ChevronRightIcon />
                                                    </button>
                                                </li>
                                            )}
                                            {item.__typename === "Link" && (
                                                <li key={`mobile_dd_${item.sys.id}`}>
                                                    <Link
                                                        onClick={onClickOutside}
                                                        {...item}
                                                        className={style.navigationButton}
                                                    />
                                                </li>
                                            )}
                                        </React.Fragment>
                                    )
                                })
                            )}
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    )
}

export default HeaderMobile

HeaderMobile.propTypes = HeaderPropTypes
